import React from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";

const Layout = ({ childern }) => {
  return (
    <div className="dashboard w-full min-h-screen  flex">
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8 ">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex">{childern}</main>
      </main>
    </div>
  );
};

export default Layout;
